export const CODE_SNIPPETS = {
  full: `// Full Syntax API - Odoo-API
GET /api/v1/odoo/res.partner
Authorization: Bearer YOUR_API_KEY
X-Odoo-Instance: your-instance.odoo.com

// Response
{
  "status": 200,
  "records": [    
    {
		"id": 1,
		"name": "YOUR NAME",
		"email": "YOUR EMAIL",
		"phone": "YOUR PHONE",
		"mobile": "YOUR MOBILE",
		"street": "YOUR STREET",
		"country_id": "YOUR COUNTRY",
		"city": "YOUR CITY",
		"zip": "YOUR ZIP",
		"website": "YOUR WEBSITE",
		"is_company": "YOUR COMPANY",		
	} 
  ],  
}`,
  integrated: `// Integrated Mode - AWS Powered
import OdooAPI from '@odoo-api/client';

const client = new OdooAPI({
  instance: 'your-instance.odoo.com',
  integration: 'aws-managed'
});

const partners = await client
  .model('res.partner')
  .filter([['active', '=', true]])
  .fields(['name', 'email', 'phone'])
  .execute();

console.log(partners); // Real-time Odoo data ✓`
};
